module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-inox-brushed-4049-panel.fc5c0337.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-inox-brushed-4049-panel.jpg
// module id = 1118
// module chunks = 37